// ============================================================
// FACILITIES — DEMO / PLACEHOLDER DATA
// Replace with the hospital's actual facilities and photos.
// Images are stored locally in /public/images/.
// ============================================================

export const FACILITIES = [
  {
    slug: "consultation-rooms",
    name: "Consultation Rooms",
    icon: "clipboard",
    image: "/images/consultation-room.jpg",
    description:
      "Comfortable, private consultation rooms where doctors can listen, examine and explain without rushing. Demo description — update with actual facility details.",
    isDemo: true,
  },
  {
    slug: "patient-waiting-area",
    name: "Patient Waiting Area",
    icon: "armchair",
    image: "/images/waiting-area.jpg",
    description:
      "A clean, calm waiting area designed for patients and attendants, with seating and clear guidance from the front desk. Demo description — update with actual facility details.",
    isDemo: true,
  },
  {
    slug: "diagnostic-support",
    name: "Diagnostic Support",
    icon: "microscope",
    image: "/images/facility-equipment.jpg",
    description:
      "Diagnostic support to assist doctors in confirming a diagnosis quickly and accurately. Demo description — update with the actual tests and equipment available.",
    isDemo: true,
  },
  {
    slug: "pharmacy-support",
    name: "Pharmacy Support",
    icon: "pill",
    image: "/images/pharmacy.jpg",
    description:
      "Pharmacy support so prescribed medicines are easy to access after your consultation. Demo description — update with the hospital's actual pharmacy arrangements.",
    isDemo: true,
  },
  {
    slug: "clean-clinical-environment",
    name: "Clean Clinical Environment",
    icon: "sparkles",
    image: "/images/hospital-hallway.jpg",
    description:
      "Hygiene and cleanliness are maintained across all clinical areas for patient safety and comfort. Demo description — update with actual facility details.",
    isDemo: true,
  },
  {
    slug: "procedure-room",
    name: "Procedure Room",
    icon: "bed",
    image: "/images/facility-ward.jpg",
    description:
      "A prepared procedure room for minor clinical procedures and dressings, with a focus on safety and hygiene. Demo description — update with actual facility details.",
    isDemo: true,
  },
];
